import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { CardHeader } from "../../../components/cards";
import { Header } from "../../../components/header";
import { SendIcon } from "../../../components/icons";
import { useUser } from "../hooks";

type IUserParams = {
  id: string;
};

export const User: React.FC = () => {
  const { id } = useParams<IUserParams>();
  const navigate = useNavigate();
  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, loading } = useUser(+id!);
  return (
    <>
      <Header
        title={`Utilisateur`}
        subtitle={`${data?.user?.result?.firstname} ${data?.user?.result?.lastname}`}
        buttons={[
          {
            actionText: "Modifier",
            bgColor: "indigo",
            textColor: "white",
            link: `/user/${id}/update`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="section">
          <div className="element">
            <div className="card">
              <CardHeader title="Informations Générales" />
              <div className="flex ">
                <div className="w-1/2 mr-1 ">
                  <div className="w-full mt-3">
                    <p className="label">Nom</p>
                    <input
                      className="input w-full"
                      value={data?.user?.result?.lastname}
                      disabled
                    />
                  </div>
                </div>
                <div className="w-1/2 ml-1">
                  <div className="w-full mt-3">
                    <p className="label">Prénom</p>
                    <input
                      className="input w-full"
                      value={data?.user?.result?.firstname}
                      disabled
                    />
                  </div>
                </div>
              </div>

              <div className="flex ">
                <div className="w-1/2 mr-1 ">
                  <div className="w-full mt-3">
                    <p className="label">Email</p>
                    <input
                      className="input w-full"
                      value={data?.user?.result?.email}
                      disabled
                    />
                  </div>
                </div>
                <div className="w-1/2 ml-1">
                  <div className="w-full mt-3">
                    <p className="label">Téléphone</p>
                    <input
                      className="input w-full"
                      value={data?.user?.result?.phone}
                      disabled
                    />
                  </div>
                </div>
              </div>

              <div className="w-full mt-3">
                <p className="label">Rôle</p>
                <input
                  disabled
                  className="input w-full"
                  value={data?.user.result?.role}
                />
              </div>
            </div>
          </div>
          <div className="element">
            <div className="card">
              <CardHeader title="Sites" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
